import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { CompanyLifecycleRepository } from '@app/domain/ports/tpv/company-lifecycle.repository';
import { UpdateCompanyRequest } from '@app/data/dtos/tpv/company-update.dto';

/**
 * Mock del ciclo de vida de Company para pruebas sin backend (toggle tpvUseMocks).
 * Simula latencia y siempre resuelve con éxito. (Las unidades viven en UnitMockDataSource.)
 */
@Injectable()
export class CompanyLifecycleMockDataSource extends CompanyLifecycleRepository {
  override updateCompany(_idCompany: string, _payload: UpdateCompanyRequest): Observable<void> {
    return of(void 0).pipe(delay(400));
  }

  override deleteCompany(_idCompany: string): Observable<void> {
    return of(void 0).pipe(delay(400));
  }
}
